import src from "IMAGE";
export default { src, width: 50, height: 48, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
